import CreateBook from "./create-book.page";

export default CreateBook;
